// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                                   from 'firebase/functions';

// ===== Services =====

import getCurrentActionOrigin       from './getCurrentActionOrigin';

// ===== Inerfaces =====

import {
    IGetBookInviteClaimLinkPayload,
}                                   from '../interfaces';

const getBookInviteClaimLink = async ({
    test,
    assignmentId,
}: {
    test: boolean,
    assignmentId: string,
}): Promise<string> => {
    const functions = getFunctions();
    const callable = httpsCallable<
        IGetBookInviteClaimLinkPayload,
        string
    >(
        functions,
        'getBookInviteClaimLink',
    );
    const actionOrigin = getCurrentActionOrigin();
    const payload: IGetBookInviteClaimLinkPayload = {
        test,
        assignmentId,
    };
    if (actionOrigin) payload.actionOrigin = actionOrigin;
    return callable(payload).then((result) => result.data as string);
};

export default getBookInviteClaimLink;
